'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/grid.ejs');
const templateCSS = require('../templates/grid.css.ejs');
const CSSView = require('./css');

module.exports = Backbone.View.extend({
    className: 'view-landing',
    events: {
        'click .category-button': 'routeCategory'
    },
    /**
     *
     */
    initialize: function(options) {
    	_.bindAll(this, 'render', 'renderedToDom', 'remove');

      this.cms = options.cms;
    	this.collection = this.model.get('collection');
      this.professionals = this.model.get('professionals');

      this.user = this.model.get('user');

      this.uid = options.uid;
      this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
      this.css = this.model.get('copy')['customization'];

      this.$el.addClass(this.style_id);

      this.state = this.model.get('window');

      this.sortedCategories = this.sortAllCategories();
      this.sortedProfessionals = this.sortAllProfessionals();

      this.listenTo(this.collection, 'change:active', this.onChangeCatActive.bind(this));
      this.listenTo(this.collection, 'change:isSubmitted', this.onChangeCatSubmitted.bind(this));
      this.listenTo(this.collection, 'change:totalAllocatedVotes', this.onChangeTotalAllocatedVotes.bind(this));
      this.listenTo(this.professionals, 'change:active', this.onChangeProfessionalActive.bind(this));

      this.listenTo(this.state, 'change:appState', function() {
        var updatedProfessionals = this.sortAllProfessionals();
        var updatedCategories = this.sortAllCategories();

        if((!_.isEqual(updatedProfessionals, this.sortedProfessionals)) ||  (!_.isEqual(updatedCategories, this.sortedCategories))) {
          this.sortedCategories = updatedCategories;
          this.sortedProfessionals = updatedProfessionals;
          this.updateCategories();
        } else if(this.state.get('appState') == 'winner') {
          this.$el.find('.category-button').addClass('active');
          PubSub.trigger('openAllCategories');
        }

      }.bind(this));

      // Add in the logic to add and remove the active status when all the categories close
      this.listenTo( PubSub, 'closeAllCategories', function(viewToOpen, id) {
        /* MMA-609:
         * iOS 8.1 on iPhone 5C seems to have problems resolving the initial animation and removeClass('active') calls.
         * The .category-button divs seem to get stuck in a half active state, even when the DOM Inspector shows that
         * they do not have the .active class applied.
         * Wrapping it in a setTimeout with a zero delay puts this code back into the JS event loop and
         * allows all everything else to finish before executing this code.
         */
        setTimeout( function() {
          this.$el.find('.category-button.active').removeClass('active');
          this.$el.find('.category-button[data-category-id="'+id+'"]').addClass('active');
        }.bind(this), 0);

      }.bind( this ));
    },
    /**
     *
     */
    render: function() {

      if(this.CSSView) this.CSSView.remove();

      this.CSSView = new CSSView({
        model: this.css,
        namespace: '#' + this.uid + ' .' + this.style_id + '.' + this.className,
        template: templateCSS
      });

      Backbone.$('head').append(this.CSSView.render().$el);

      var sectionOneCategories = this.sortedCategories.filter(function(category) {
        return category.vote_section === '1';
      });
      var sectionTwoCategories = this.sortedCategories.filter(function(category) {
        return category.vote_section === '2';
      })

      var model = {
        sectionOneCategories: sectionOneCategories,
        sectionTwoCategories: sectionTwoCategories,
        professionalCategories: this.sortedProfessionals,
        copy: this.model.get('copy'),
        user: this.user.toJSON().voteData,
        closedCatDescription: this.cms.get('text').view_grid.closed_cat_description,
        socialCopy: this.cms.get('text').view_social_category,
        liveVoteBattleDescription: this.cms.get('text').view_live_vote_category.hashtag_battle_description,
        voteLimit: this.cms.turboVote.get('voteLimit'),
        window: this.state.get('appState')
      };

      this.$el.html(template(model));
      return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        if(this.state.get('appState') == 'winner') {
          this.$el.find('.category-button').addClass('active');
          PubSub.trigger('openAllCategories', true);
        }
    },
    /**
     * When the active categories change, we need to refresh the grid view
     * to ensure the active ones are updated to the top of the grid
     */
    onChangeCatActive: function() {
      var updatedCategories = this.sortAllCategories();
      if(!_.isEqual(updatedCategories, this.sortedCategories)) {
        this.sortedCategories = updatedCategories;
        this.updateCategories();
      }
    },
    /**
     * Handler for when the isSubmitted attribute of a category changes
     */
    onChangeCatSubmitted: function(category) {
      if(category.get('isSubmitted')) {
        this.$('.votes-submitted.cat-' + category.get('id')).show();
        this.$('.votes-remaining-wrapper.cat-' + category.get('id')).hide();
      } else {
        this.$('.votes-submitted.cat-' + category.get('id')).hide();
        this.$('.votes-remaining-wrapper.cat-' + category.get('id')).show();
      }
    },
    /**
     * When the active professional categories change, we need to refresh the
     * grid view to ensure the active ones are updated to the top of the grid
     */
    onChangeProfessionalActive: function() {
      var updatedProfessionals = this.sortAllProfessionals();
      if(!_.isEqual(updatedProfessionals, this.sortedProfessionals)) {
        this.sortedProfessionals = updatedProfessionals;
        this.updateCategories();
      }
    },
    /**
     * Handler for when the totalAllocatedVotes attribute of a category changes
     */
    onChangeTotalAllocatedVotes: function(category) {
      const voteLimit = this.cms.turboVote.get('voteLimit');
      const votesRemaining = voteLimit - category.get('totalAllocatedVotes');
      const isLiveVote = _.checkIfTrue( this.cms.get('text').live_vote );

      this.$('.votes-remaining.cat-' + category.get('id')).text(votesRemaining);

      // when user allocated all votes, display confirmation modal
      if(!votesRemaining && !isLiveVote) PubSub.trigger('modalConfirm', category);
    },
    /**
     * [sortAllProfessionals description]
     * @return {[type]} [description]
     */
    sortAllProfessionals: function() {
      var updatedProfessional = [];

      var sortedCategories = _.filter(this.professionals.models, function(model) {
        var modelToStore = _.clone(model.attributes, true);

        modelToStore.winner = [];
        modelToStore.contestantCount = modelToStore.voteData.length;
        modelToStore.voteData = [];
        modelToStore.copy = {};
        modelToStore.ad = [];
        modelToStore.collectionID = model.id;

        updatedProfessional.push(modelToStore);
      });

      return updatedProfessional;

    },
    /**
     *
     */
    updateCategories: _.debounce(function() {
      PubSub.trigger('closeAllCategories', null, null, function() {
        this.render();
        this.renderedToDom();

        if(this.state.get('appState') == 'winner') {
          this.$el.find('.category-button').addClass('active');
          PubSub.trigger('openAllCategories');
        } else {
          PubSub.trigger('openFirstCategory');
        }
      }.bind(this));
    }, 200),
    /**
     *
     */
    sortAllCategories: function() {
        var openCategories = [];
        var closedCategories = [];
        var unsortedCategories = [];
        var categories = [];

        var sortedCategories = _.filter(this.collection.models, function(model) {
          var modelToStore = _.extend({}, _.clone(model.attributes, true));
          modelToStore.collectionID = model.id;

          // always default the winner value and voteData to []
          // ensures changes for voteData and winner happens in the category
          // NOT the grid viw
          modelToStore.winner = [];
          modelToStore.copy = {};
          modelToStore.ad = [];
          modelToStore.contestantCount = modelToStore.voteData.length;
          modelToStore.voteData = [];

          unsortedCategories.push(modelToStore);

          if(modelToStore.active == '1') {
            openCategories.push(modelToStore);
          } else {
            closedCategories.push(modelToStore);
          }
        });

        if(this.state.get('appState') !== 'open') {
          return unsortedCategories;
        }

        categories = openCategories.concat(closedCategories);

        return categories;
    },
    /**
     *
     */
    routeCategory: _.debounce(function(e) {
        var $category = $(e.currentTarget);
        var category = null;
        var categoryID = $category.data('category-id');

        $category.addClass('toggle-animations');

        if(/(professional)/.test($category[0].className)) {
          category = this.professionals.getCategoryById(categoryID.toString());
        } else {
          category = this.collection.getCategoryById(categoryID.toString());
        }

        if( category.get('voteData').length === 0 ) {
          return;
        }

        if($category.hasClass('active')) {
          PubSub.trigger('hideCategory', category, $category);
        } else {
          $category.addClass('active');
          PubSub.trigger('navigate', category.get('displayName'), { isCategory: true, trigger: true });
        }

        // Sometimes toggling categories won't trigger image unveiling. Only scroll events will. 
        // Dispatch scroll.unveil event to trigger lazy loading on category toggle 
        $(window).trigger('scroll.unveil');

    }, 700, { leading: true, trailing: false })
});



// WEBPACK FOOTER //
// ./app/scripts/views/grid.js